import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import jwt_decode from 'jwt-decode';
import { logger } from "../../assets/conf_urls.json"
import { Levels } from './levels.enum';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private user_info_obj: { name: string, role: string } = null;

  constructor(private http: HttpClient) {
  }

  
  logUser(componentName: string, nameOfUser: string, msg: string, lvl: Levels) {
    let body = {
      username: nameOfUser,
      message: componentName + ": " + msg,
      level: this.getLevelString(lvl)
    }
    this.http.post(logger.logEntry, body).subscribe(data => { });
  }

  log(componentName: string, msg: string, lvl: Levels) {
    if (!this.user_info_obj) { this.user_info_obj = jwt_decode(localStorage.getItem('accessToken')); }

    let body = {
      username: this.user_info_obj.name,
      message: componentName + ": " + msg,
      level: this.getLevelString(lvl)
    };
    this.http.post(logger.logEntry, body).subscribe(data => { });
  }

  getLevelString(lvl: Levels): string {
    switch (lvl) {
      case Levels.info:
        return "info";
      case Levels.warning:
        return "warning";
      case Levels.error:
        return "error";
    }
  }
}
